import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import {
  Pricing,
  ListPricingResponse
} from '@spilca/order_ts/v1/order/model_pricing_pb';
import {
  QUERY_KEYS,
  useFilter,
  convertInfiniteDataToArray,
  getTotalCountFromInfiniteData,
  getStandardNextPageParam
} from '@monorepo/helpers';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useGetPriceLists = (
  config = { pageSize: 20, defaultFilter: {}, enabled: false }
) => {
  const { pageSize, defaultFilter, enabled } = config;
  const { filter } = useFilter();

  const readyFilter = { ...filter, ...defaultFilter };

  const request = useGetRequest(REQUEST_TYPES.GET_PRICE_LISTS);

  const response = useInfiniteQuery<ListPricingResponse.AsObject>({
    queryKey: [QUERY_KEYS.LIST_PRICING, readyFilter],
    queryFn: (queryParams) => request({ ...queryParams, pageSize }),
    initialPageParam: 1,
    staleTime: 10*60*1000,
    gcTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled,
    getNextPageParam: getStandardNextPageParam,

  });

  const convertDataForGrid = (
    data: InfiniteData<ListPricingResponse.AsObject> | undefined
  ): Pricing.AsObject[] =>
    convertInfiniteDataToArray<ListPricingResponse.AsObject, Pricing.AsObject>(
      data,
      'itemsList',
      (items) => items.map((el, index) => ({ ...el, externalId: index + 1 }))
    );

  const getTotalCount = (
    data: InfiniteData<ListPricingResponse.AsObject> | undefined
  ) => getTotalCountFromInfiniteData(data);

  return { ...response, convertDataForGrid, getTotalCount };
};

export default useGetPriceLists;
